/* eslint-disable react/display-name */ function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  font-weight: 400;\n  font-size: 16px;\n  padding: 50px;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from 'styled-components';
import { CircularProgress, Text } from '@tapresearch/ui/components';
export var Loading = styled.div(_templateObject(), function(props) {
    return props.color;
});
export default function(param) {
    var _param_color = param.color, color = _param_color === void 0 ? 'blue.500' : _param_color;
    return /*#__PURE__*/ React.createElement(Loading, {
        "data-testid": "loading-indicator"
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        size: "70px",
        thickness: "7px",
        isIndeterminate: true,
        color: color
    }), /*#__PURE__*/ React.createElement(Text, {
        color: "gray.400",
        my: 2,
        textTransform: "uppercase",
        letterSpacing: "1px",
        fontWeight: "semibold"
    }, "Loading"));
};
